var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dialog',{ref:"dialog",attrs:{"title":_vm.$t('message.confirm'),"message":"この伝票をコピーしますか？","cancel-text":_vm.$t('message.no'),"submit-text":'複製'},on:{"submit":function($event){return _vm.submit()}}})}
var staticRenderFns = []

export { render, staticRenderFns }